module.exports = "请尽可能详尽地说明这个需求的用例和场景。"